/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-06-18 11:39:50
 * @LastEditors: hongye
 * @LastEditTime: 2025-11-21 14:06:33
 * @Description: file content
 */
import request from '@/service/request'
enum Api {
  ADDRESS_PAGE = '/lmdmAddress/getAddressByPostCode'
}

export default class addressService {
  /**
   * 地址模糊查询
   * @param data
   * @returns
   */
  static page(data: Record<string, any>): Promise<any> {
    return request.post(Api.ADDRESS_PAGE, data)
  }
  
  /**
   * 三级地址查询
   * @param data
   * @returns data {
   *  parentId: 父级id,
   *  dataType: 数据类型 1：新数据 2：老数据
   * }
   */
  static querySysArea(data: any): Promise<any> {
    return request.post('/address/querySysArea', data)
  }
  /**
   * 所有地址查询
   * @param data
   * @returns
   */
  static queryAllSysArea(): Promise<any> {
    return request.post('/address/queryAllSysArea', {})
  }
}
